<template>
  <MainLayout :currentLang="currentLang">
    <section class="banner-section p-relative">
      <img :src="currentLang == 'en' ? bannerEnUrl : bannerUrl" class="w-100" alt="" />
      <div class="banner-content p-absolute">
        <div class="fly-in">
          <h2 v-html="$t('message.index.banner.title')"></h2>
          <p class="desc" v-html="$t('message.index.banner.subTitle')"></p>
          <div class="input-box">
            <el-input class="w-100" type="text" :placeholder="$t('message.index.banner.fillEmail')" v-model="businessEmail"></el-input>
            <el-button type="primary" @click="jumpContact">{{ $t('message.index.banner.btnText') }}</el-button>
          </div>
          <div class="desc2" v-html="$t('message.index.banner.desc')"></div>
        </div>
      </div>
    </section>

    <section class="plate-section">
      <h3 class="section-title" v-html="$t('message.index.plate.title')"></h3>
      <el-row type="flex" class="plate-row flex-wrap">
        <el-col :span="12">
          <div class="plate-item d-flex justify-content-between type1 cursor-pointer" @click="handleView('/Wisdom_AI_Applications')">
            <div class="left-text">
              <h3>
                {{ $t('message.index.plate.platform1') }}
              </h3>
              <p v-html="$t('message.index.plate.desc1')"></p>
            </div>
            <div class="right-icon">
              <img src="@/assets/images/home/plate1.svg" alt="" />
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="plate-item d-flex justify-content-between type2 cursor-pointer" @click="handleView('/Wisdom_BI_Analysis')">
            <div class="left-text">
              <h3>
                {{ $t('message.index.plate.platform2') }}
              </h3>
              <p v-html="$t('message.index.plate.desc2')"></p>
            </div>
            <div class="right-icon">
              <img src="@/assets/images/home/plate2.svg" alt="" />
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="plate-item d-flex align-items-center justify-content-center type3 horizontal cursor-pointer" @click="handleView('/Business_Manage_System')">
            <img class="plate-icon" src="@/assets/images/home/plate3.svg" alt="" />
            <h3>
              {{ $t('message.index.plate.platform3') }}
            </h3>
            <p v-html="$t('message.index.plate.desc3')"></p>
            <!-- <img class="arrow-icon" src="@/assets/images/home/arrow.svg" alt="" /> -->
          </div>
        </el-col>
        <el-col :span="24">
          <div class="plate-item d-flex align-items-center justify-content-center type4 horizontal cursor-pointer" @click="handleView('/Intelligent_Device_Management_Platform')">
            <img class="plate-icon" src="@/assets/images/home/plate4.svg" alt="" />
            <h3>
              {{ $t('message.index.plate.platform4') }}
            </h3>
            <p v-html="$t('message.index.plate.desc4')"></p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="plate-item d-flex justify-content-between type1">
            <div class="left-text">
              <h3>
                {{ $t('message.index.plate.platform5') }}
              </h3>
              <p v-html="$t('message.index.plate.desc5')"></p>
            </div>
            <div class="right-icon">
              <img src="@/assets/images/home/plate5.svg" alt="" />
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="plate-item d-flex justify-content-between type3 cursor-pointer" @click="handleView('/AI_Robot')">
            <div class="left-text">
              <h3>
                {{ $t('message.index.plate.platform6') }}
              </h3>
              <p v-html="$t('message.index.plate.desc6')"></p>
            </div>
            <div class="right-icon">
              <img src="@/assets/images/home/plate6.svg" alt="" />
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="plate-item d-flex justify-content-between type2 cursor-pointer" @click="handleView('/Automation')">
            <div class="left-text">
              <h3>
                {{ $t('message.index.plate.platform7') }}
              </h3>
              <p v-html="$t('message.index.plate.desc7')"></p>
            </div>
            <div class="right-icon">
              <img src="@/assets/images/home/plate7.svg" alt="" />
            </div>
          </div>
        </el-col>
      </el-row>
    </section>

    <div class="solution-section p-relative">
      <h3 class="section-title">
        {{ $t('message.index.solution.title') }}
      </h3>
      <img :src="currentLang == 'cn' ? solutionUrl : solutionEnUrl " class="banner w-100" alt="" />
      <div class="hover-item hover-item1 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel14')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc14'),
        className: 'hover-dialog1',
        url: '/Staff_Manage',
      })"></div>
      <div class="hover-item hover-item2 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel15')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc15'),
        className: 'hover-dialog2',
        url: '/Vehicle_Manage',
      })"></div>
      <div class="hover-item hover-item3 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel13')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc13'),
        className: 'hover-dialog3',
        url: '/Property_Manage',
      })"></div>
      <div class="hover-item hover-item4 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel11')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc11'),
        className: 'hover-dialog4',
        url: '/Operational_Standard_Manage',
      })"></div>
      <div class="hover-item hover-item5 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel12')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc12'),
        className: 'hover-dialog5',
        url: '/Device_Inspection_Maintenance_Manage',
      })"></div>
      <div class="hover-item hover-item6 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel1')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc1'),
        className: 'hover-dialog6',
        url: '/Supply_Chain_Manage',
      })"></div>
      <div class="hover-item hover-item7 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel3')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc3'),
        className: 'hover-dialog7',
        url: '/Park_Manage',
      })"></div>
      <div class="hover-item hover-item8 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel5')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc5'),
        className: 'hover-dialog8',
        url: '/Loading_and_Unloading_Vehicle_Storage',
      })"></div>
      <div class="hover-item hover-item9 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel10')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc10'),
        className: 'hover-dialog9',
        url: '/Finished_Product_Storage_and_Tallying',
      })"></div>
      <div class="hover-item hover-item10 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel8')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc8'),
        className: 'hover-dialog10',
        url: '/Production_Process_Data_Manage',
      })"></div>
      <div class="hover-item hover-item11 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel2')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc2'),
        className: 'hover-dialog11',
        url: '/Material_External_Warehouse_Manage',
      })"></div>
      <div class="hover-item hover-item12 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel4')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc4'),
        className: 'hover-dialog12',
        url: '/Platform_Manage',
      })"></div>
      <div class="hover-item hover-item13 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel6')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc6'),
        className: 'hover-dialog13',
        url: '/Delivery_Transport',
      })"></div>
      <div class="hover-item hover-item14 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel9')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc9'),
        className: 'hover-dialog14',
        url: '/Order_Picking',
      })"></div>
      <div class="hover-item hover-item15 p-absolute cursor-pointer" @mouseover="handleSolutionHover({
        scene: `${$t('message.header.sceneLabel7')}${$t('message.index.solution.scene')}`,
        desc: $t('message.header.sceneDesc7'),
        className: 'hover-dialog15',
        url: '/Finished_Product_External_Warehouse_Manage',
      })"></div>
      <div class="hover-dialog p-absolute cursor-pointer" :class="hoverSolutionInfo.className" @click="handleView(hoverSolutionInfo.url)" v-if="showDialog">
        <div class="row1 d-flex align-items-center justify-content-between">
          <h3>{{ hoverSolutionInfo.scene }}</h3>
          <img src="@/assets/images/home/plate2.svg" class="" alt="" />
        </div>
        <div class="row2 d-flex align-items-center justify-content-between">
          <p v-html="hoverSolutionInfo.desc.replace(/，/g, '，<br/>')"></p>
          <img src="@/assets/images/home/arrow-gray.svg" class="" alt="" />
        </div>
      </div>
    </div>

    <div class="enterprise-section">
      <h3 class="section-title">
        {{ $t('message.index.enterprise.title') }}
      </h3>

      <div class="enterprise-content d-flex justify-content-between">
        <div class="left-part">
          <div class="top-title d-flex align-items-center justify-content-center">
            <h3>{{ $t('message.index.enterprise.subTitle1') }}</h3>
            <!-- <div class="img-box">
              <img src="@/assets/images/home/enterprise1.svg" alt="">
            </div> -->
          </div>
          <div class="brand-main d-flex">
            <div class="brand-image" v-for="item in 49" :key="item">
              <img :src="require(`@/assets/images/home/brand/${item}.svg`)" alt="">
            </div>
          </div>
          <div class="quote">
            ......
          </div>
        </div>

        <div class="right-part">
          <div class="top-title d-flex align-items-center justify-content-center">
            <h3>{{ $t('message.index.enterprise.subTitle2') }}</h3>
            <!-- <div class="img-box">
              <img src="@/assets/images/home/enterprise2.svg" alt="">
            </div> -->
          </div>
          <div class="customer-main d-flex">
            <div class="brand-image" v-for="item in 28" :key="item">
              <img :src="require(`@/assets/images/home/brand/${item+49}.png`)" alt="">
            </div>
          </div>
          <div class="quote">
            ......
          </div>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '../components/MainLayout.vue';

export default {
  name: 'Home',
  props: ['currentLang'],
  components: {
    MainLayout,
  },
  data() {
    return {
      bannerUrl: require('@/assets/images/home/banner.gif'),
      bannerEnUrl: require('@/assets/images/home/banner-en.gif'),
      solutionUrl: require('@/assets/images/home/banner-solution.png'),
      solutionEnUrl: require('@/assets/images/home/banner-solution-en.png'),
      businessEmail: '',
      showDialog: false,
      hoverSolutionInfo: {
        scene: '',
        desc: '',
        className: '',
        url: '',
      }
    };
  },
  methods: {
    handleSolutionHover(data) {
      this.hoverSolutionInfo.scene = data.scene;
      this.hoverSolutionInfo.desc = data.desc;
      this.hoverSolutionInfo.className = data.className;
      this.hoverSolutionInfo.url = data.url;
      this.showDialog = true;
    },
    handleView(data) {
      this.$router.push(`${data}`);
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    jumpContact() {
      this.$router.push(`/Contact?email=${this.businessEmail}`);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.banner-section {
  height: 841px;
  .banner-content {
    top: 50%;
    left: 113px;
    transform: translateY(-50%);
    h2 {
      font-size: 50px;
      font-weight: 600;
      line-height: 80px;
    }
    p.desc {
      margin-top: 73px;
      color: #202b52;
      font-size: 18px;
      line-height: 28px;
    }
    .input-box {
      margin-top: 78px;
      width: 451px;
      height: 58px;
      position: relative;
      .el-input {
        height: 100%;
        ::v-deep {
          .el-input__inner {
            height: 58px;
            line-height: 58px;
            border-radius: 13px !important;
          }
        }
      }
      .el-button {
        position: absolute;
        height: 49px;
        top: 29px;
        right: 5px;
        transform: translateY(-50%);
        box-sizing: border-box;
        border-radius: 13px;
        background-color: #1a65ff;
        padding: 12px 42px;
        font-family: Figtree, Arial, Helvetica;
        font-weight: 700;
        font-size: 18px;
      }
    }
    .desc2 {
      margin-top: 12px;
      color: #202b52;
      font-size: 12px;
      line-height: 14px;
    }
  }
}
.section-title {
  font-size: 40px;
  font-weight: 600;
  text-align: center;
}
.plate-section {
  margin: 0 280px;
  .section-title {
    margin: 76.5px 0 51.5px;
  }
  .plate-row {
    gap: 20px;
    .el-col-8 {
      width: calc((100% - 40px) / 3);
    }
    .el-col-12 {
      width: calc(50% - 10px);
    }
    .plate-item {
      padding: 26px 34px;
      border-radius: 15px;
      transition: all 0.3s ease;
      &:hover {
        box-shadow: 0 0 14px 1px rgba(8, 77, 218, 0.3);
      }
      &.type1 {
        background: linear-gradient(to bottom, #e2f4f7 0, #f5fcfe 100%);
      }
      &.type2 {
        background: linear-gradient(to bottom, #ecebfc 0, #fef8fe 100%);
      }
      &.type3 {
        background: linear-gradient(to bottom, rgba(234, 237, 250, 1) 0, rgba(234, 237, 250, 0.2) 100%);
      }
      &.type4 {
        background: linear-gradient(to right, #e5f0ff 0, #f0f7ff 100%);
      }
      &.horizontal {
        .plate-icon {
          width: 48px;
        }
        h3 {
          font-size: 28px;
          line-height: 34px;
          font-weight: 500;
          margin-left: 31px;
        }
        p {
          margin-left: 15px;
          font-size: 18px;
          line-height: 28px;
        }
        .arrow-icon {
          margin-left: 20px;
          width: 27px;
        }
      }
      .left-text {
        h3 {
          font-size: 28px;
          line-height: 34px;
          font-weight: 500;
        }
        p {
          width: 110%;
          margin-top: 35px;
          font-size: 18px;
          line-height: 28px;
        }
      }
      .right-icon {
        img {
          width: 48px;
        }
      }
    }
  }
}
.solution-section {
  .section-title {
    margin-top: 87.5px;
  }
  .banner {
    margin-top: -90px;
  }
  .hover-item {
    width: 295px;
    height: 157px;
    transform: rotate3d(1, 1, 1, -75deg);
  }
  .hover-dialog {
    width: 417px;
    background: linear-gradient(to bottom, #ecebfc 0, #fef8fe 100%);
    border-radius: 15px;
    padding: 24px 22px 31px 38px;
    &:hover {
      box-shadow: 0 0 14px 1px rgba(8, 77, 218, 0.3);
    }
    .row1 {
      h3 {
        font-weight: 500;
        font-size: 28px;
        line-height: 34px;
        max-width: 85%;
      }
      img {
        width: 48px;
      }
    }
    .row2 {
      margin-top: 54px;
      p {
        font-size: 18px;
        line-height: 28px;
        color: rgba(1, 13, 57, 0.8);
      }
      img {
        width: 40px;
        padding-right: 13px;
      }
    }
  }

  .hover-item1 {
    top: 290px;
    left: 350px;
  }
  .hover-dialog1 {
    top: 130px;
    left: 575px;
  }
  .hover-item2 {
    top: 294px;
    left: 615px;
    transform: rotate3d(1, 1, 1, -77deg);
  }
  .hover-dialog2 {
    top: 130px;
    left: 845px;
  }
  .hover-item3 {
    top: 290px;
    left: 890px;
  }
  .hover-dialog3 {
    top: 120px;
    right: 380px;
  }
  .hover-item4 {
    top: 280px;
    right: 450px;
    transform: rotate3d(1, 1, 1, -77deg);
    width: 320px;
    height: 175px;
  }
  .hover-dialog4 {
    top: 110px;
    right: 125px;
  }
  .hover-item5 {
    top: 290px;
    right: 190px;
  }
  .hover-dialog5 {
    top: 130px;
    right: 410px;
  }
  .hover-item6 {
    top: 435px;
    left: 212px;
  }
  .hover-dialog6 {
    top: 245px;
    left: 445px;
  }
  .hover-item7 {
    top: 422px;
    left: 482px;
  }
  .hover-dialog7 {
    top: 255px;
    left: 695px;
  }
  .hover-item8 {
    top: 430px;
    left: 747px;
  }
  .hover-dialog8 {
    top: 263px;
    left: 975px;
  }
  .hover-item9 {
    top: 420px;
    right: 604px;
  }
  .hover-dialog9 {
    top: 247px;
    right: 275px;
  }
  .hover-item10 {
    top: 430px;
    right: 335px;
  }
  .hover-dialog10 {
    top: 247px;
    right: 25px;
  }
  .hover-item11 {
    bottom: 80px;
    left: 278px;
  }
  .hover-dialog11 {
    bottom: 195px;
    left: 495px;
  }
  .hover-item12 {
    bottom: 80px;
    left: 545px;
  }
  .hover-dialog12 {
    bottom: 195px;
    left: 765px;
  }
  .hover-item13 {
    bottom: 66px;
    left: 800px;
  }
  .hover-dialog13 {
    bottom: 190px;
    left: 1015px;
  }
  .hover-item14 {
    bottom: 82px;
    right: 540px;
  }
  .hover-dialog14 {
    bottom: 195px;
    right: 205px;
  }
  .hover-item15 {
    bottom: 83px;
    right: 265px;
  }
  .hover-dialog15 {
    bottom: 255px;
    right: 25px;
  }
}
.enterprise-section {
  .section-title {
    margin: 79.5px 0 76.5px;
  }
  .enterprise-content {
    margin: 0 244px 129px;
    gap: 22px;
    .left-part, .right-part {
      padding: 32px 36px 12px;
      background-color: #F6F6FB;
      border-radius: 15px;
      .top-title {
        align-items: center;
        justify-content: space-between;
        margin-bottom: 27px;
        h3 {
          font-size: 30px;
          line-height: 36px;
          font-weight: 500;
        }
        img {
          width: 48px;
        }
      }
      p.desc {
        margin-top: 18px;
        margin-bottom: 28px;
        font-size: 18px;
        line-height: 28px;
      }
      .brand-main {
        flex-wrap: wrap;
        justify-content: space-between;
        width: 818px;
        .brand-image {
          width: 109px;
          height: 61px;
          border-radius: 5px;
          box-shadow: 0 0 2px rgba(0, 0, 0, 0.15);
          background-color: #fff;
          margin-bottom: 9px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .customer-main {
        width: 470px;
        flex-wrap: wrap;
        justify-content: space-between;
        .brand-image {
          width: 109px;
          height: 61px;
          border-radius: 5px;
          box-shadow: 0 0 2px rgba(0, 0, 0, 0.15);
          background-color: #fff;
          margin-bottom: 9px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .quote {
        margin-top: -12px;
        font-size: 30px;
        font-weight: 500;
        line-height: 36px;
        text-align: center;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .layout__main {
    .banner-section {
      height: 950px;
      img {
        height: 100%;
      }
      .banner-content {
        top: 47%;
        left: 43px;
        transform: translateY(-50%);
        h2 {
          font-size: 76px;
          line-height: 120px;
        }
        p.desc {
          margin-top: 43px;
          font-size: 34px;
          line-height: 48px;
        }
        .input-box {
          width: 810px;
          height: 100px;
          margin-top: 43px;
          .el-input {
            ::v-deep {
              .el-input__inner {
                height: 100px;
                line-height: 100px;
                border-radius: 24px !important;
                font-size: 38px;
              }
            }
          }
          .el-button {
            height: 82px;
            top: 50px;
            right: 12px;
            font-size: 34px;
            border-radius: 24px !important;
          }
        }
        .desc2 {
          margin-top: 20px;
          font-size: 32px;
          line-height: 54px;
        }
      }
    }
    .section-title {
      font-size: 64px;
    }
    .plate-section {
      margin: 0 80px;
      .section-title {
        margin: 86.5px 0 61.5px;
      }
      .plate-row {
        gap: 30px;
        .el-col-8 {
          width: calc((100% - 60px) / 3);
        }
        .el-col-12 {
          width: calc(50% - 15px);
        }
        .plate-item {
          padding: 26px 34px;
          border-radius: 15px;
          &.horizontal {
            .plate-icon {
              width: 68px;
            }
            h3 {
              font-size: 48px;
              line-height: 54px;
              margin-left: 31px;
            }
            p {
              margin-left: 15px;
              font-size: 28px;
              line-height: 48px;
            }
          }
          .left-text {
            h3 {
              font-size: 48px;
              line-height: 54px;
              font-weight: 500;
            }
            p {
              margin-top: 35px;
              font-size: 28px;
              line-height: 48px;
            }
          }
          .right-icon {
            img {
              width: 68px;
            }
          }
        }
      }
    }
    .solution-section {
      .hover-dialog {
        .row1 {
          h3 {
            font-size: 38px;
            line-height: 54px;
          }
          img {
            width: 68px;
          }
        }
        .row2 {
          margin-top: 64px;
          p {
            font-size: 28px;
            line-height: 38px;
          }
          img {
            width: 60px;
            padding-right: 23px;
          }
        }
      }
    }
    .enterprise-section {
      .section-title {
        margin: 79.5px 0 76.5px;
      }
      .enterprise-content {
        margin: 0 64px 129px;
        gap: 22px;
        flex-wrap: wrap;
        .left-part, .right-part {
          padding: 32px 36px 12px;
          background-color: #F6F6FB;
          border-radius: 15px;
          .top-title {
            h3 {
              font-size: 50px;
              line-height: 56px;
            }
          }
          .brand-main {
            flex-wrap: wrap;
            justify-content: space-between;
            width: 100%;
            gap: 15px;
            .brand-image {
              width: calc((100% - 90px) / 7);
              height: 81px;
              border-radius: 10px;
              margin-bottom: 9px;
              img {
                width: 100%;
              }
            }
          }
          .customer-main {
            width: 100%;
            flex-wrap: wrap;
            justify-content: space-between;
            gap: 15px;
            .brand-image {
              width: calc((100% - 90px) / 7);
              height: 81px;
              border-radius: 10px;
              margin-bottom: 9px;
              img {
                width: 100%;
              }
            }
          }
          .quote {
            margin-top: -12px;
            font-size: 30px;
            font-weight: 500;
            line-height: 36px;
            text-align: center;
          }
        }
      }
    }
  }
}
.en-container {
  .banner-section .banner-content h2 {
    position: relative;
    margin-top: -94px;
    font-size: 46px;
    line-height: 70px;
  }
  .banner-section .banner-content p.desc {
    margin-top: 50px;
  }
}
</style>
